<template>
  <div class="uc-task-statuses">
    <TirPmPopover width="16.25rem" style="width: 100%" :position="PopoverPositionEnum.Bottom">
      <template #default>
        <TirPmButton
          v-if="!selected"
          :variant="TirPmButtonVariantEnum.SecondaryState"
          :size="TirPmButtonSizeEnum.Small"
          class="task-parameters-table_item_name_button"
          @click="$emit('isOpened', isOpened)"
        >
          <template #leftSlot>
            <PlusIcon style="width: 1rem; height: 1rem" />
          </template>
          <p>Добавить статус</p>
        </TirPmButton>
        <slot name="selected">
          <TirPmGlobalStatus v-if="selected" :value="selected"></TirPmGlobalStatus>
        </slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </TirPmPopover>
  </div>
</template>

<script setup lang="ts">
import { TirPmGlobalStatus } from "@/components/task-parameters-form/components";
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmOptionList,
  TirPmOptionListGroupSeparator,
  TirPmOptionListItemElement,
  TirPmPopover,
  TirPmStatus,
  TirPmStatusBgEnum,
  TirPmStatusTextEnum,
} from "tir-components";
import { PlusIcon } from "tir-style-system/icons/outline";
// Импорты из Vue 3 Composition API
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
const values = ref([]);
const selectedData = ref();

function update(value: any) {
  console.log("value update", value);
}
// Определение пропсов компонента
const props = defineProps({
  isOpened: { type: Boolean, value: false },
  selected: { type: Object, value: null },
});
function checkOpenOptions(value: any) {
  console.log("value", value);
}
// // Определение эмиттеров событий компонента
const emits = defineEmits<{
  isOpened: [Boolean]; // Событие при клике на кнопку "Выход"
}>();

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }
</script>

<style lang="scss">
.uc-task-statuses {
  // padding: 10px;
}
</style>